export const LOW_CREDIT_THRESHOLD = 0.2;
